<div class="back-button d-flex align-items-center" (click)="onClick()">
  <ng-container *ngIf="showIcon">
    <div class="responsive-flex-wrapper">
      <app-icon name="arrow_right_alt" size="small"></app-icon>
    </div>
  </ng-container>
  <span>{{ label }}</span>
</div>
